// Cloudflare Turnstile SITE key.
//
// This key is PUBLIC — it is rendered into the page HTML, so committing it here is
// safe (unlike the SECRET key, which stays a server-side secret as TURNSTILE_SECRET_KEY).
//
// Why it's here and not a build env var: kanarix-app is configured via wrangler.toml,
// so Cloudflare only lets you add *secrets* in the dashboard — and Vite needs this value
// at BUILD time (it's baked into the bundle), which secrets can't provide. So paste the
// site key below. Get it from: Cloudflare → Turnstile → your widget → "Site Key".
//
// Leave it empty ('') to disable the widget (e.g. local dev). When empty AND the server
// secret is unset, auth still works (Turnstile is skipped end-to-end).
export const TURNSTILE_SITE_KEY =
  (import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined) || '0x4AAAAAADqidmVppvcECOg5';
